import React, { Component } from 'react';
import { authHeader } from '../../components/auth-header';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import { userService } from '../../services/user.service';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppBar, Toolbar } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { InputBase } from '@material-ui/core'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    numberField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 100,
    },
    radio: {
        height: 30,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        marginRight: 5,
    },
    editor: {
        height: 320,
    },
    editor2: {
        height: 300
    },
    fab: {
        marginTop: theme.spacing.unit * 2,
        position: 'absolute',
        right: theme.spacing.unit * 2,
    },
    grow: {
        flexGrow: 1,
    },


    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    }
});

const divStyle = {
    marginBottom: '20px',
    padding: ' 10px'
};
const selectStyle = {
    marginLeft: '10px'
};

class AnimalList extends Component {
    static displayName = AnimalList.name;

    constructor(props) {
        super(props);

        var compo = this;
        this.state = { chov: "Vyber chov", animals: [], breedings: [], loading: false, filterLoading: true, search: '', page: 0, rowsPerPage: 10 };
        this.handleChange = this.handleChange.bind(this);
        this.renderBusyIndicator = this.renderBusyIndicator.bind(this);
        this.search = this.search.bind(this);
        this.renderAnimalsTable = this.renderAnimalsTable.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        fetch('api/Animal/Breedings', { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                if (Array.isArray(data)) {
                    localStorage.setItem('breedings', JSON.stringify(data));
                    compo.setState({ breedings: data, filterLoading: false });
                } else {
                    userService.logout();
                    this.props.history.push("/");
                }

            }).catch(function () {
                compo.setState({ breedings: JSON.parse(localStorage.getItem("breedings") ? localStorage.getItem("breedings") : []), filterLoading: false });
                console.log("request failed, fetching data from storage");
            });
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    renderFilter(breedings, classes) {
        return (
            <div>
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={classes.grow} variant="h6" color="inherit">Filter</Typography>
                    </Toolbar>
                </AppBar>
                <Paper style={divStyle}>
                    <List padding="none">
                        <ListItem>
                            <InputLabel htmlFor="chov">Chov</InputLabel>
                            <Select
                                style={selectStyle}
                                value={this.state.chov}
                                onChange={this.handleChange}
                                input={<Input name="chov" id="chov" />}
                                autoWidth
                            >
                                <MenuItem value="Vyber chov">
                                    <em>Vyber chov</em>
                                </MenuItem>
                                {breedings.map(breeding =>
                                    <MenuItem key={breeding} value={breeding}>{breeding}</MenuItem>
                                )}
                            </Select>
                        </ListItem>
                    </List>
                </Paper>
            </div>
        );

    }
    renderAnimalsTable(animals, classes) {
        const { rowsPerPage, page } = this.state;
        return (
            <div>
                <Paper style={divStyle} className={classes.root}>
                    <Table padding="none">
                        <TableBody>
                            {animals.length > 0 ? animals.filter(a => a.hide !== true).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(animal =>
                                <TableRow hover={true} style={{cursor: 'pointer'}} onClick={() => this.props.history.push("/animal-detail/" + animal.animalCode)}
                                    key={animal.animalCode + animal.dateInsem}>
                                    <TableCell padding="dense">{animal.animalCode} </TableCell>

                            </TableRow>
                        ) :
                            <TableRow>
                                <TableCell>Žiadne výsledky </TableCell>
                                </TableRow>}
                            </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        labelRowsPerPage='Počet záznamov'
                        component="div"
                        count={this.state.animals.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    />
                </Paper>
            </div>
        );
    }

    search() {
        var comp = this;
        var change = false;

        this.state.animals.forEach(function (animal) {
            if (animal.animalCode.indexOf(comp.state.search) === -1) {
                change = animal.hide === false ? true : change;
                animal.hide = true;
            } else {
                change = animal.hide === true ? true : change;
                animal.hide = false;
            }
        });
        if (change) {
            this.setState({ animals: this.state.animals });
        }

    }

    handleChange(event) {
        var compo = this;
        compo.setState({ [event.target.name]: event.target.value, loading: true, page: 0 });
        compo.handleChange = compo.handleChange.bind(this);

        fetch('api/Animal/Animals?breeding=' + event.target.value, { headers: authHeader() })
            .then(response => response.json())
            .then(data => {
                //get current animals
                var currentAnimals = localStorage.getItem('animals') && Array.isArray(JSON.parse(localStorage.getItem('animals'))) ? JSON.parse(localStorage.getItem('animals')) : [];
                //replace breeding list with fresh :) animals
                currentAnimals = currentAnimals.filter(animList => animList.breeding !== event.target.value);
                //add breeding (cause we got none)
                data.forEach(function (ins) {
                    ins.breedingCode = compo.state.chov;
                });
                currentAnimals.push({ breeding: event.target.value, animals: data });

                localStorage.setItem('animals', JSON.stringify(currentAnimals))
                compo.setState({ animals: data, loading: false });
            }).catch(function (err) {
                if (localStorage.getItem("animals") && JSON.parse(localStorage.getItem('animals')).filter(animList => animList.breeding === event.target.value).length > 0) {
                    compo.setState({ animals: JSON.parse(localStorage.getItem('animals')).filter(animList => animList.breeding === event.target.value)[0].animals, loading: false });
                } else {
                    compo.setState({ loading: false });
                }


                console.log("request failed, fetching data from storage");
            });
    };

    renderBusyIndicator(props) {
        return (
            <Paper style={{ padding: 15 }}>
                <CircularProgress className={props.progress} />
            </Paper>
        );
    }

    render() {
        const { classes } = this.props;

        let contents = this.state.loading
            ? this.renderBusyIndicator(this.props)
            : this.renderAnimalsTable(this.state.animals, this.props);//FetchData.renderForecastsTable(this.state.forecasts, this.props);
        let filter = this.state.filterLoading
            ? this.renderBusyIndicator(this.props)
            : this.renderFilter(this.state.breedings, this.props);

        return (
            <div className={classes.root}>
                {filter}
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={classes.grow} variant="h6" color="inherit">Zoznam zvierat</Typography>
                        <div className={classes.search}>
                            <div button="true" className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <InputBase
                                placeholder="Hľadať…"
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={e => this.setState({ search: e.target.value }, () => this.search())}
                            />
                        </div>
                    </Toolbar>
                </AppBar>
                {contents}
            </div>
        );
    }
}
AnimalList.propTypes = {
    classes: PropTypes.object.isRequired
};
export default (withStyles(styles)(AnimalList));


// WEBPACK FOOTER //
// ./src/components/technik/AnimalList.jsx